/* eslint-disable react/prop-types */
import React from "react";
import styled from "styled-components";
import { Avatar as AntAvatar } from "antd";
import { getAvatarShortenedName } from "@/utils";

export const RAAvatar = ({ name = "", size = 40, ...props }) => (
	<AntAvatar
		icon={<AvatarIcon size={size / 2 - 6}>{getAvatarShortenedName(name)}</AvatarIcon>}
		size={size}
		{...props}
	/>
);

const AvatarIcon = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #212731;
	color: #ffb11a;
	width: 100%;
	height: 100%;
	font-family: "DM Sans";
	font-family: 700;
	font-size: ${({ size }) => size}px;
`;
